import Vue from 'vue'
import store from '@/store'

export default (baseURL) => {
  let API = Vue.axios.create(
    {
      baseURL: baseURL || '//panel-scannergps.com/api',
      withCredentials: false,
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      }
    })
  API.interceptors.request.use(config => {
    const userId = store.getters.getUserId
    const token = store.getters.getToken
    if (token) {
      config.headers.Authorization = userId + ' ' + token
    }
    return config
  }, err => {
    return new Promise((resolve, reject) => {
      reject(err)
    })
  })
  let rejections = 2
  API.interceptors.response.use(response => Promise.resolve(response), error => {
    const status = error.response ? error.response.status : undefined
    console.log(rejections)
    if (!status && rejections) {
      return (new Promise((resolve) => {
        setTimeout(() => {
          resolve(API.request(error.config))
        }, 5000 * (2 - rejections + 1))
      })).finally(() => {
        rejections--
      })
    }
    return Promise.reject(error)
  })
  return API
}



// WEBPACK FOOTER //
// ./src/api/index.js